import type { EstabelecimentoOption, PromocaoOption, SituacaoOption } from "../../../services/cadastroAplicativo"

export type { EstabelecimentoOption, PromocaoOption, SituacaoOption }

export type CadastroAplicativoModel = {
    appNome: string
    urlAppAndroid: string
    urlAppIphone: string
    codigoFireBase: string
    urlAcesso: string
    urlAcesso2: string
    urlAcesso3: string
    urlArtesDivulgacao: string
    packageName: string
    categorias: string
    appNomeAlternativo: string
    situacao: number
    ativo: boolean
    idEstabelecimentoPrincipal: number | null
    idPromocaoPrincipal: number | null
    dataPrevisaoLancamento: string
    dataLancamento: string
    estabelecimentos: EstabelecimentoOption[]
    promocoes: PromocaoOption[]
    situacaoOptions: SituacaoOption[]
    podeEditar: boolean
}

export const CadastroAplicativoInicial: CadastroAplicativoModel = {
    appNome: "",
    urlAppAndroid: "",
    urlAppIphone: "",
    codigoFireBase: "",
    urlAcesso: "",
    urlAcesso2: "",
    urlAcesso3: "",
    urlArtesDivulgacao: "",
    packageName: "",
    categorias: "",
    appNomeAlternativo: "",
    situacao: 1,
    ativo: true,
    idEstabelecimentoPrincipal: null,
    idPromocaoPrincipal: null,
    dataPrevisaoLancamento: "",
    dataLancamento: "",
    estabelecimentos: [],
    promocoes: [],
    situacaoOptions: [],
    podeEditar: true,
}
